class MFRComparison {
    constructor( i, e ) {
        this.$index = i;
        this.$element = $( e );

        this.selectors = {
            wrapper: ".comparison-section__inner",
            leftImage: ".comparison-section__left",
            slider: '[name="slider"]',
            thumb: ".comparison-section__thumb"
        }

        this.init();
    }

    init() {
        this.$leftImage = this.$element.find( this.selectors.leftImage );
        this.$slider = this.$element.find( this.selectors.slider );
        this.$thumb = this.$element.find( this.selectors.thumb );
        this.$wrapper = this.$element.find( this.selectors.wrapper );

        this.updateImage();
        this.initMouseEvents();

        this.$slider.on( "input change", this.__handleRangeChange.bind( this ) );
    }

    __handleRangeChange( e ) {
        this.updateImage( this.$slider.val() )
    }

    initMouseEvents() {
        this.$wrapper.on( "mouseover mousemove", this.debounce( ( e ) => {
            // e = Mouse click event.
            const rect = e.target.getBoundingClientRect();
            const x = e.clientX - rect.left; //x position within the element.
            const percentage = x / this.$wrapper.width() * 100;
    
            this.updateImage( percentage )
        }, 1 ) );

        this.$wrapper.on( "mouseout", this.debounce( ( e ) => {
            this.updateImage( 50 )
        }, 1 ) )
    }

    updateImage( value ) {
        this.$leftImage.css( {
            clipPath: `inset( 0px ${ 100 - value }% 0px 0px )`
        } );

        this.$thumb.css( {
            left: `${ value }%`
        } );
    }

    debounce(func, delay) {
        let debounceTimer
        return function() {
            const context = this
            const args = arguments
                clearTimeout(debounceTimer)
                debounceTimer = setTimeout(() => { func.apply(context, args) }, delay)
        }
    }
}